<template>
  <nav class="site-navbar navbar navbar-default navbar-inverse navbar-fixed-top navbar-mega"
       role="navigation">

    <div class="navbar-container container-fluid">
      <!-- Navbar Collapse -->
      <div class="navbar-collapse">
        <!-- Navbar Toolbar -->
        <ul class="nav navbar-toolbar menubutton">
          <li class="nav-item" id="toggleMenubar">
            <a class="nav-link" data-toggle="menubar" href="#" role="button" v-bind:title="t('headerMenuTitle')">
              <i class="icon hamburger hamburger-arrow-left">
                <span class="sr-only">Toggle menubar</span>
                <span class="hamburger-bar"></span>
              </i>
            </a>
          </li>
        </ul>
        <!-- End Navbar Toolbar -->

        <!-- Navbar Toolbar Right -->
        <ul class="nav navbar-toolbar navbar-right navbar-toolbar-right">
          <plus-menu/>
          <!--<li class="nav-item">-->
          <!--<a @click="click" class="nav-link icon wb-search js-search-btn" data-toggle="collapse" href="#" data-target="#site-navbar-search"-->
          <!--role="button">-->
          <!--<span class="sr-only">Toggle Search</span>-->
          <!--</a>-->
          <!--</li>-->
          <notifications/>
          <header-basket/>
          <user/>
        </ul>
        <!-- End Navbar Toolbar Right -->

        <div class="navbar-brand navbar-brand-center">
          <router-link :to="{name: 'Dashboard'}">
            <span class="company-name">{{ companyName }}</span>
            <!--            <img class="navbar-brand-logo navbar-brand-logo-normal" src="/static/assets/images/repnode-n-logo.svg"-->
            <!--                 title="Repnode">-->
            <!--            <img class="navbar-brand-logo navbar-brand-logo-special" src="/static/assets/images/repnode-n-logo-colored.svg"-->
            <!--                 title="Repnode">-->
          </router-link>
        </div>
      </div>
      <!-- End Navbar Collapse -->

      <!-- Site Navbar Seach -->
      <div class="collapse navbar-search-overlap" id="site-navbar-search">
        <form role="search">
          <div class="form-group">
            <div class="input-search">
              <button type="button" class="input-search-close icon wb-close" data-target="#site-navbar-search"
                      data-toggle="collapse" aria-label="Close"></button>
              <input type="text" class="form-control js-input-search" name="site-search" placeholder="Search...">
              <i class="input-search-icon wb-search" aria-hidden="true"></i>
            </div>
          </div>
        </form>
      </div>
      <!-- End Site Navbar Seach -->
    </div>
  </nav>
</template>

<script>
import Notifications from '../templates/widgets/header-notifications'
import UserModel     from '../../model/resource/User'
import User          from '../templates/widgets/header-user'
import PlusMenu      from '../templates/widgets/header-plus-menu'
import HeaderBasket  from './../templates/widgets/header-basket'

export default {
  components: {
    Notifications,
    User,
    PlusMenu,
    HeaderBasket
  },

  data () {
    return {
      companyName: null
    }
  },

  created () {
    UserModel
      .getUserParams((userData) => {
        this.companyName = userData.mpar_MyCompanyName
      }, (error) => {this.handleApiError(error)}, true)
  }

  // methods: {
  //   click (event) {
  //     event.preventDefault()
  //     event.stopPropagation()
  //     this.$toastr('info', 'Coming soon ...', '')
  //   }
  // }
}
</script>

<style scoped>

.site-navbar .navbar-container .navbar-brand-center > a {
  display: flex;
  align-items: center;
  height: 100%;
}

.site-navbar .navbar-container .navbar-brand-center > a:hover {
  text-decoration: none;
}

.navbar-brand.navbar-brand-center {
  height: 100%;
}

.company-name {
  color: #FFF;
  margin-top: 2px;
}
</style>
